// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bllb","buttons":"styles_buttons__2yrFz"};